export function Container({ children, className = "" }) {
  return <div className={`max-w-7xl mx-auto px-5 pt-3 pb-8 md:pt-4 md:pb-10 ${className}`}>{children}</div>;
}

export function PageTitle({ eyebrow, title, sub }) {
  return (
    <div className="mb-6 md:mb-8">
      {eyebrow && <div className="inline-block font-mono-sl text-xs uppercase tracking-widest bg-sl-tertiary nb-border rounded-full px-3 py-1 mb-3" data-testid="page-eyebrow">{eyebrow}</div>}
      <h1 className="font-heading text-4xl md:text-6xl font-black tracking-tighter leading-[0.95] max-w-4xl">{title}</h1>
      {sub && <p className="mt-3 text-base md:text-lg text-neutral-700 max-w-2xl">{sub}</p>}
    </div>
  );
}

export function Chip({ children, color = "primary" }) {
  const bg = { primary: "bg-sl-primary", secondary: "bg-sl-secondary", tertiary: "bg-sl-tertiary", accent: "bg-sl-accent" }[color];
  return <span className={`inline-block font-mono-sl text-[10px] uppercase tracking-widest ${bg} nb-border rounded-full px-2 py-0.5`}>{children}</span>;
}

export function NbButton({ children, onClick, color = "primary", type = "button", className = "", disabled, ...rest }) {
  const bg = { primary: "bg-sl-primary", secondary: "bg-sl-secondary", tertiary: "bg-sl-tertiary", accent: "bg-sl-accent", black: "bg-black text-white", white: "bg-white" }[color];
  return (
    <button type={type} disabled={disabled} onClick={onClick} className={`px-5 py-3 font-heading font-bold uppercase tracking-tight text-sm rounded-lg nb-border nb-shadow nb-hover disabled:opacity-50 active:translate-x-[2px] active:translate-y-[2px] active:shadow-[2px_2px_0_0_#0A0A0A] ${bg} ${className}`} {...rest}>
      {children}
    </button>
  );
}

export function NbCard({ children, className = "", color = "white", ...rest }) {
  const bg = { white: "bg-white", primary: "bg-sl-primary", secondary: "bg-sl-secondary", tertiary: "bg-sl-tertiary", accent: "bg-sl-accent" }[color];
  return <div className={`${bg} nb-border rounded-xl nb-shadow p-6 ${className}`} {...rest}>{children}</div>;
}
